module.exports = __webpack_public_path__ + "img/VisitorDefaultSlide.96de48d0.png";